if (!customElements.get("flexible-images")) {
  customElements.define(
    "flexible-images",
    class FlexibleImages extends HTMLElement {
      constructor() {
        super();
        this.images = this.querySelectorAll(".flexible-image-block");
        this.isIntersected = false;
        this.initObservers();
        this.addEventListeners();
      }

      initObservers() {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              this.activateFirstImage();
              this.isIntersected = true;
              this.observer.disconnect();
            }
          },
          {
            rootMargin: "-300px 0px -300px 0px",
          },
        );
        this.observer.observe(this);
      }

      addEventListeners() {
        this.images.forEach((image) => {
          if (!webvista.isMobileScreen()) {
            image.addEventListener("mouseenter", () =>
              this.setActiveImage(image),
            );
          }
          image.addEventListener("click", () => this.setActiveImage(image));
        });
      }

      activateFirstImage() {
        this.images[0]?.classList.add("active");
        this.updateOverlays(this.images[0]);
      }

      setActiveImage(image) {
        if (!this.isIntersected) return;

        this.images.forEach((img) => img.classList.remove("active"));
        image.classList.add("active");
        this.updateOverlays(image);
      }

      updateOverlays(activeImage) {
        const activeIndex = Array.from(this.images).indexOf(activeImage);
        this.images.forEach((img, i) => {
          const distance = Math.abs(i - activeIndex);
          if (distance === 0) {
            img.style.setProperty("--overlay-opacity", "0");
          } else {
            const opacity = 0.3 + (distance - 1) * 0.1;
            img.style.setProperty("--overlay-opacity", opacity);
          }
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    },
  );
}